import { ca } from '@cian/analytics';

export const trackChangeType = (ea, el) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: ea,
    label: el,
  });
};
